<script setup lang="ts">
import { storeToRefs } from 'pinia';
import { useStatisticsWizardStore } from '../../stores';
import StatisticsKindChooser from './StatisticsKindChooser.vue';
import { computed, onMounted } from 'vue';
import { getChoosableYears } from '../../utils/statistics.utils';
import { useAuthStore } from '@shared';
import { useRouter } from 'vue-router';

const router = useRouter();

const statisticsWizardStore = useStatisticsWizardStore();
const { statisticsData, showStatisticsTypeChooser } = storeToRefs(statisticsWizardStore);

const authStore = useAuthStore();
const { personalData } = storeToRefs(authStore);

const choosableYears = computed(() =>
  personalData.value ? getChoosableYears(personalData.value.year) : getChoosableYears(undefined)
);

const isCopy = computed(() => router.currentRoute.value.name === 'statisticsWizardCopy');

onMounted(() => {
  if (!isCopy.value) {
    statisticsWizardStore.openInfoModal();
  }
});
</script>

<template>
  <div class="h-100 d-flex flex-column align-center justify-center gap-2 align-content-stretch text-center">
    <div class="d-flex w-100">
      <div class="w-40"></div>
      <div class="w-20">
        <div v-if="showStatisticsTypeChooser">
          <h2 class="font-weight-light pb-3">{{ $t('statistics.wizard.label.year') }}</h2>
          <v-select
            v-model="statisticsData.year"
            variant="outlined"
            :hide-details="true"
            density="comfortable"
            @update:model-value="statisticsWizardStore.onStatisticsYearChange"
            :items="choosableYears" />
        </div>
      </div>
      <div class="w-40 align-content-end text-left">
        <v-icon
          icon="mdi-information"
          id="icon"
          color="blue"
          class="pb-4 pl-6"
          size="x-large"
          @click.stop.prevent="statisticsWizardStore.openInfoModal" />
      </div>
    </div>

    <div>
      <h2 class="font-weight-light pb-3">{{ $t('statistics.wizard.label.statisticsType') }}</h2>
      <statistics-kind-chooser
        :size="220"
        v-model="statisticsData.kind"
        @update:model-value="statisticsWizardStore.onStatisticsKindChange" />
    </div>
  </div>
</template>
